import React from 'react';
import { ZapIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function AnnouncementBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'TIM'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEK'
  }];
  return <div className="w-full bg-navy px-5 py-2.5 text-center" data-id="element-18" data-mp="eu7e6m5tt5eu">
      <div className="mx-auto flex w-full max-w-[540px] flex-col items-center gap-0.5" data-id="element-19" data-mp="9wff986rkj15">
        <p className="flex items-center justify-center gap-2 text-[10px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-20" data-mp="5ukfi84hedph">
          <ZapIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-21" data-mp="ufz0i3kpiz9" />
          Lanceringstilbuddet slutter om:
        </p>

        <p className="flex items-baseline justify-center gap-2 text-white" aria-label={`Lanceringstilbuddet slutter om ${hours} timer, ${minutes} minutter og ${seconds} sekunder`} data-id="element-22" data-mp="3s33istm60y4p">
          {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-23" data-mp="68i65ldo5mdc" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="font-display text-xl text-white/40" data-id="element-24" data-mp="6amk6w5a81rc">
                  :
                </span>}
              <span className="flex items-baseline gap-1" aria-hidden="true" data-id="element-25" data-mp="3sgi6bwad3myl">
                <span className="font-display text-2xl font-bold leading-none tabular-nums" data-id="element-26" data-mp="18ng1k1px0tc">
                  {unit.value}
                </span>
                <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-white/60" data-id="element-27" data-mp="ozjgt6o5j6cq">
                  {unit.label}
                </span>
              </span>
            </React.Fragment>)}
        </p>
      </div>
    </div>;
}